import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import { compose } from 'recompose';
import plusIcon from '../../assets/plus.png';
import minusIcon from '../../assets/minus.png';

import { withAuthorization } from '../Session';

const defaultTask = {
  id: -1,
  name: 'No Task Selected',
  date: '',
  link: '',
  status: '',
}

const defaultClass = {
  tasks: []
}

class ClassesPageBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        
      ],
      selectedClass: {},
      selectedTask: defaultTask,
      user: {},
      loadingClass: false,
      loadingTask: false,
      loadingDetails: false,
    }
    this.fb = this.props.firebase
  }

  setSelectedClass = (cls) => {
    this.setState({selectedClass: cls})
  }

  setSelectedTask = (task) => {
    this.setState({selectedTask: task})
  }

  componentDidMount() {
    this.fb.getUser().then((user) =>{
      this.setState({data: user.classes})
      this.fb.user = user
      if (this.state.data != null && this.state.data.length>0) {
        this.setState({selectedClass: this.state.data[0]})
        console.log("this.state.selectedClass.tasks: "+JSON.stringify(this.state.selectedClass.tasks))
        if (this.state.selectedClass.tasks != null && this.state.selectedClass.tasks !== undefined && this.state.selectedClass.tasks.length > 0) {
          console.log("selected task not empty")
          this.setState({selectedTask: this.state.selectedClass.tasks[0]})
        }
      } 
    })
  }

  createClass = (cls) => {
    this.setState({loadingClass: true})
    this.fb.addClass({uid: this.fb.auth.currentUser.uid, class: cls}).then((user) => {
      console.log("recieved classes: "+JSON.stringify(user))
      this.fb.user = user
      this.setState({data: user.classes})
      var currentId = cls.id
      let currentClass = user.classes.find(x => x.id === currentId) 
      this.setState({selectedClass: currentClass, loadingClass: false})
    })
  }

  createTask = (task) => {
    if (this.state.selectedClass != undefined) {
      if (Object.keys(this.state.selectedClass).length > 0) {
        this.setState({loadingTask: true})
        this.fb.addTask({uid: this.fb.auth.currentUser.uid, task: task, classID: this.state.selectedClass.id}).then((user) => {
        console.log("recieved classes: "+JSON.stringify(user))
        this.setState({data: user.classes})
        let currentId = this.state.selectedClass.id
        let currentClass = user.classes.find(x => x.id === currentId) 
        this.setState({selectedClass: currentClass})
        this.setState({loadingTask: false})
      })
      }
    } else {
      console.log("no")
    }
  }

  deleteSelectedTask = () => {
    if(window.confirm('Are you sure you wish to delete ' + this.state.selectedTask.name + "?")) {
      this.fb.deleteTask({uid: this.fb.auth.currentUser.uid, taskID: this.state.selectedTask.id, classID: this.state.selectedClass.id}).then((user) => {
        this.setSelectedTask(defaultTask)
        this.setState({data: user.classes})
        let currentId = this.state.selectedClass.id
        console.log(JSON.stringify(user))
        let currentClass = user.classes.find(x => x.id === currentId)
        this.setState({selectedClass: currentClass})
      })
    }
  }

  deleteSelectedClass = () => {
    if(window.confirm('Are you sure you wish to delete ' + this.state.selectedClass.name + "?")) {
      this.fb.deleteClass({uid: this.fb.auth.currentUser.uid, classID: this.state.selectedClass.id}).then((user) => {
        this.setSelectedTask(defaultTask)
        this.setState({data: user.classes})
        if (user.classes.length == 0) {
          this.setState({selectedClass: {}})
        } else {
          this.setState({selectedClass: user.classes[0]})
        }
        console.log(JSON.stringify(user))
      })
    }
  }

  updateTask = (taskID, newTask) => {
    this.setState({loadingDetails: true})
    this.fb.updateTask({uid: this.fb.auth.currentUser.uid, taskID: taskID, task: newTask, classID: this.state.selectedClass.id}).then((user) => {
      this.setSelectedTask(newTask)
      this.setState({data: user.classes})
      let currentId = this.state.selectedClass.id
      let currentClass = user.classes.find(x => x.id === currentId)
      this.setState({selectedClass: currentClass})
      this.setState({loadingDetails: false})
    })
  }

  updateStatus = (task, newStatus) => {
    var updatedTask = Object.assign({}, task);
    updatedTask.status = newStatus;
    this.updateTask(updatedTask.id, updatedTask);
  }

  render() {
    const style = {
      div: {
        float: 'left',
        backgroundColor: '#ffffff',
        height: '100%',
        color: "#6290C8"
      },
      classesDiv: {
        width: '20%',
        borderRightColor: "#A9A9A9",
        borderRightWidth: "1px",
        borderRightStyle: "solid",
        overflow: "scroll"
      },
      tasksDiv: {
        width: '40%',
        borderRightColor: "#A9A9A9",
        borderRightWidth: "1px",
        borderRightStyle: "solid",
        overflow: "scroll",
      },
      detailsDiv: {
        width: '40%',
        overflow: "scroll",
      },
      h1: {
        textAlign: 'center',
        color: "#6290C8",
        fontSize: "25px"
      },
      mainDiv: {
        height: '100%',
      },
      hr: {
        //borderColor: 'black',
        margin: 0,
        padding: 0,
        color: "#6290C8",
      },
      ul: {
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        
      },
      li: {
      },
      button: {
        width: '100%',
        backgroundColor: '#ffffff',
        fontSize: '20px',
        height: '50px',
        outline: 'none',
        color: "#6290C8",
        border: "none",
        borderBottomColor: "#A9A9A9",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderTopColor: "#A9A9A9",
        borderTopStyle: "solid",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      buttonSel: {
        width: '100%',
        backgroundColor: "#6290C8",
        fontSize: '20px',
        height: '50px',
        outline: 'none',
        color: "#ffffff",
        border: "none",
        borderBottomColor: "#A9A9A9",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderTopColor: "#A9A9A9",
        borderTopWidth: "1px",
        borderTopStyle: "solid",
        overflow: "hidden",
        textOverflow: "ellipsis",
        borderTopColor: "#A9A9A9",
        borderTopStyle: "solid",
      },
      topBtn: {
        
      },
      plusButton: {
        width: "50px",
        heigth: "50px",
        fontSize: '20px',
        backgroundColor: "#ffffff",
        outline: 'none',
        color: "#ffffff",
        border: "none",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "auto",
        borderRadius: "25px",
        opacity: 1,
      },
      plusIcon: {
        width: "50px",
        heigth: "50px",
        borderRadius: "25px",
      },
      plusMinusButtons: {
        width: "50px",
        heigth: "50px",
        fontSize: '20px',
        backgroundColor: "#ffffff",
        outline: 'none',
        color: "#ffffff",
        border: "none",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "auto",
        borderRadius: "25px",
        opacity: 1,
      },
      buttonsDiv: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '25%',
        marginRight: '25%',
      },
      buttonLi: {
        width: "100%"
      },
      form: {
        width: "98%",
        margin: "1%"
      },
      formField: {
        width: "100%",
        outline: "none",
        border: "none",
        borderBottomColor: "#A9A9A9",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
      },
      formButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "auto",
        marginTop: "8px",
        outline: "none",
        border: "none",
        backgroundColor: "#6290C8",
        color: "#ffffff",
        padding: "8px",
        borderRadius: "5px",
        fontSize: "15px"
      },
      editButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "auto",
        marginTop: "8px",
        outline: "none",
        border: "none",
        backgroundColor: "#6290C8",
        color: "#ffffff",
        padding: "8px",
        borderRadius: "5px",
        fontSize: "15px"

      },
      deleteButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "auto",
        marginTop: "8px",
        outline: "none",
        border: "none",
        backgroundColor: "#ff6961",
        color: "white",
        padding: "8px",
        borderRadius: "5px",
        fontSize: "15px",
      },
      statusButton: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "auto",
        marginTop: "8px",
        outline: "none",
        border: "none",
        backgroundColor: "#5bbd5b",
        color: "white",
        padding: "8px",
        borderRadius: "5px",
        fontSize: "15px",        
      },
      taskSectionH: {
        width: "100%",
        textAlign: "center",
        padding: "8px"
      }
    }

    var data = this.state.data
    if (data == null || data.length <= 0) {
      data = [{}]
    }
    
    

    

    return (
      <div id='Main' style={style.mainDiv}>
        <Classes 
          style={Object.assign({"div": Object.assign(style.classesDiv, style.div)}, {"h1": style.h1}, {"hr": style.hr}, {"ul": style.ul}, {"button": style.button}, {"buttonSel": style.buttonSel}, {"plusButton": style.plusButton}, {"buttonLi": style.buttonLi}, {"plusIcon": style.plusIcon}, {formField: style.formField}, {form: style.form},{formButton: style.formButton},{
            "plusMinusButtons": style.plusMinusButtons}, {"buttonsDiv": style.buttonsDiv}
          )} 
          data={data}
          onClick={this.setSelectedClass}
          deleteFunction={this.deleteSelectedClass}
          selectedClass={this.state.selectedClass}
          createClass={this.createClass}
          loadingClass={this.state.loadingClass}
        />

        <Tasks 
          style={Object.assign({"div": Object.assign(style.tasksDiv, style.div)}, {"h1": style.h1}, {"hr": style.hr}, {"ul": style.ul}, {"button": style.button}, {"buttonSel": style.buttonSel}, {"plusButton": style.plusButton}, {"buttonLi": style.buttonLi}, {"plusIcon": style.plusIcon}, {formField: style.formField}, {form: style.form},{formButton: style.formButton},{taskSectionH: style.taskSectionH})}
          tasks={this.state.selectedClass!={} && this.state.selectedClass != undefined ? this.state.selectedClass.tasks!=undefined ? this.state.selectedClass.tasks : [] : []}
          onClick={this.setSelectedTask}
          selectedTask={this.state.selectedTask}
          createTask={this.createTask}
          loadingTask={this.state.loadingTask}
        />

        <Details 
          style={Object.assign({"div": Object.assign(style.detailsDiv, style.div)}, {"h1": style.h1}, {"hr": style.hr}, {"editButton": style.editButton}, {"deleteButton": style.deleteButton}, {"statusButton": style.statusButton}, {"formField": style.formField}, {"form": style.form}, {"formButton": style.formButton})}
          selectedTask={this.state.selectedTask}
          deleteFunction={this.deleteSelectedTask}
          updateStatusFunction={this.updateStatus}
          updateTask={this.updateTask}
          loadingDetails={this.state.loadingDetails}
        />
      </div>

    )
  }

};

class Classes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      style: this.props.style,
      name: "",
      formShow: false,
    };
  }

  createClass = () => {
    this.setState({formShown: false})
    let data = {name: this.state.name, tasks: [], id: Date.now()}
    this.props.createClass(data)
    this.setState({name: ""})
  }

  render() {
    return (
      <div style={this.state.style.div}>
          <h1 style={this.state.style.h1}>Classes</h1>
          <hr style={this.state.style.hr} />
          <ul style={this.state.style.ul}>
            <li>
            <div style={this.state.style.buttonsDiv}>
              <button style={this.state.style.plusMinusButtons} onClick={() => this.setState({formShown: !this.state.formShown})}>
              <img style={this.state.style.plusIcon} src={plusIcon} /></button>
              <button style={this.state.style.plusMinusButtons} onClick={() => this.props.deleteFunction()}>
                <img style={this.state.style.plusIcon} src={minusIcon} />
              </button>
            </div>
            </li>
            { this.state.formShown &&(<li style={this.state.style.form}>
              <input style={this.state.style.formField} type="text" placeholder="Class Name" value={this.state.name} onChange={(e) => {this.setState({name: e.target.value})}}/>
              <button style={this.state.style.formButton} onClick={this.createClass}>Create Class</button>
            </li>)}
            { this.props.loadingClass &&(<li style={this.state.style.form}>
              <p>Loading...</p>
            </li>)}
            {this.props.data.filter((x) => Object.keys(x).length > 0).map(
              (cls, id) => (
                <li>
                  { this.props.selectedClass.id === cls.id && (<Button 
                    style={{...this.state.style.buttonSel, borderTopWidth:id!=0?"0px":"1px"}}
                    name={cls.name}
                    onClick={() => this.props.onClick(cls)}
                  />)}
                  { this.props.selectedClass.id !== cls.id && (<Button 
                    style={{...this.state.style.button, borderTopWidth:id!=0?"0px":"1px"}}
                    name={cls.name}
                    onClick={() => this.props.onClick(cls)}
                  />)}
                </li>
                
              )

            )}
            
          </ul>
      </div>    
    )
  }
}

class Tasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      style: this.props.style,
      name: "",
      date: "",
      link: "",
      formShown: false,
    };
    
  }

  createTask = () => {
    let data = {name: this.state.name, date: this.state.date, link: this.state.link, status: "Not Started", id: Date.now()}
    this.props.createTask(data)
    this.setState({name: "", date: "", link: "", formShown: false})
  }

  render() {
    console.log("tasks: "+JSON.stringify(this.props))
    return (
      <div style={this.state.style.div}>
          <h1 style={this.state.style.h1}>Tasks</h1>
          <hr style={this.state.style.hr} />
          <ul style={this.state.style.ul}>
            <li><button style={this.state.style.plusButton} onClick={() => this.setState({formShown: !this.state.formShown})}>
              <img style={this.state.style.plusIcon} src={plusIcon} /></button></li>
            { this.state.formShown &&(<li style={this.state.style.form}>
              <input style={this.state.style.formField} type="text" placeholder="Task Name" value={this.state.name} onChange={(e) => {this.setState({name: e.target.value})}}/>
              <input style={this.state.style.formField} type="text" placeholder="Due Date" value={this.state.date} onChange={(e) => {this.setState({date: e.target.value})}}/>
              <input style={this.state.style.formField} type="text" placeholder="Link" value={this.state.link} onChange={(e) => {this.setState({link: e.target.value})}}/>
              <button style={this.state.style.formButton} onClick={this.createTask}>Create Task</button>
            </li>)}
            { this.props.loadingTask &&(<li style={this.state.style.form}>
              <p>Loading...</p>
            </li>)}
            {this.props.tasks.filter(x => x.status === "In Progress").length > 0 &&(<li><h2 style={{...this.state.style.taskSectionH, color: '#ffb347'}}>In Progress</h2></li>)}
            {this.props.tasks.filter(x => x.status === "In Progress").map(
              (task, id) => (
                <li>
                  { this.props.selectedTask.id=== task.id && (<Button 
                  style={{...this.state.style.buttonSel, borderTopWidth:id!=0?"0px":"1px"}}
                  onClick={() => this.props.onClick(task)}
                  name={task.name+" | Due: "+task.date}/>)}
                { this.props.selectedTask.id !== task.id && (<Button 
                  style={{...this.state.style.button, 
                          color: '#ffb347', borderTopWidth:id!=0?"0px":"1px"}}
                  onClick={() => this.props.onClick(task)}
                  name={task.name+" | Due: "+task.date}/>)}
                </li>
              )
            )}
            {this.props.tasks.filter(x => x.status === "Not Started").length > 0 &&(<li><h2 style={{...this.state.style.taskSectionH, color: '#ff6961'}}>Not Started</h2></li>)}
            {this.props.tasks.filter(x => x.status === "Not Started").map(
              (task, id) => (
                <li>
                  { this.props.selectedTask.id=== task.id && (<Button 
                  style={{...this.state.style.buttonSel, borderTopWidth:id!=0?"0px":"1px"}}
                  onClick={() => this.props.onClick(task)}
                  name={task.name+" | Due: "+task.date}/>)}
                { this.props.selectedTask.id !== task.id && (<Button 
                  style={{...this.state.style.button, 
                          color: '#ff6961', borderTopWidth:id!=0?"0px":"1px"}}
                  onClick={() => this.props.onClick(task)}
                  name={task.name+" | Due: "+task.date}/>)}
                </li>
              )
            )}
            {this.props.tasks.filter(x => x.status === "Finished").length > 0 &&(<li><h2 style={{...this.state.style.taskSectionH, color: '#5bbd5b'}}>Finished</h2></li>)}
            {this.props.tasks.filter(x => x.status === "Finished").map(
              (task, id) => (
                <li>
                  { this.props.selectedTask.id=== task.id && (<Button 
                  style={{...this.state.style.buttonSel, borderTopWidth:id!=0?"0px":"1px"}}
                  onClick={() => this.props.onClick(task)}
                  name={task.name+" | Due: "+task.date}/>)}
                { this.props.selectedTask.id !== task.id && (<Button 
                  style={{...this.state.style.button, 
                          color: '#5bbd5b', borderTopWidth:id!=0?"0px":"1px"}}
                  onClick={() => this.props.onClick(task)}
                  name={task.name+" | Due: "+task.date}/>)}
                </li>
              )
            )}
          </ul>
      </div>    
    )
  }
}

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      style: this.props.style,
    };
  }

  render() {
    return (
      <button 
        style={this.state.style}
        onClick={this.props.onClick}
      >{this.props.name}</button>
    )
  }
}

class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      style: this.props.style,
      editing: false,
      name: this.props.selectedTask.name,
      date: this.props.selectedTask.date,
      link: this.props.selectedTask.link,
    };
  }

  fixedLink(link) {
    if (!(link.substring(0, 8) == 'https://' || link.substring(0, 7) == 'http://')) {
      return ("https://" + link)
    }
    return (link)
  }

  visualLink(link) {
    if (link.substring(0, 8) == "https://") {
      return (link.substring(8))
    } else if (link.substring(0, 7) == "http://") {
      return (link.substring(7))
    }
    return (link)
  }

  render() {
    return(
      <div style={this.state.style.div}>
      {!this.state.editing&&!this.props.loadingDetails&&(<div>
      <h1 style={this.state.style.h1}>{this.props.selectedTask.name ? this.props.selectedTask.name:"Unnamed Task"}</h1>
      <hr style={this.state.style.hr} />
      {this.props.selectedTask.date&&<h1 style={{height: '56px', textAlign: 'center'}}>Date: {this.props.selectedTask.date}</h1>}
      {this.props.selectedTask.link&&
      <a target="_blank" style={{fontSize: '30px', textAlign: 'center', display: 'block'}}
        href={this.fixedLink(this.props.selectedTask.link)}>
          Link: {this.visualLink(this.props.selectedTask.link)}
      </a>}
      
      {this.props.selectedTask.status&&
      <h1 style={{height: '56px', textAlign: 'center'}}>Status: {this.props.selectedTask.status}</h1>
      }
      {this.props.selectedTask.id !== -1 &&
      <div>
      {this.props.selectedTask.status !== "Not Started"&&
      <button style={this.props.style.statusButton}
        onClick={() => this.props.updateStatusFunction(this.props.selectedTask, "Not Started")}
      >
        Status: Not Started
      </button>
      }

      {this.props.selectedTask.status !== "In Progress"&&
      <button style={this.props.style.statusButton}
        onClick={() => this.props.updateStatusFunction(this.props.selectedTask, "In Progress")}
      >
        Status: In Progress
      </button>
      }

      {this.props.selectedTask.status !== "Finished"&&
      <button style={this.props.style.statusButton}
        onClick={() => this.props.updateStatusFunction(this.props.selectedTask, "Finished")}
      >
        Status: Finished
      </button>
      }

      <button style={this.props.style.editButton} onClick={() => this.setState({editing: true, name: this.props.selectedTask.name, date: this.props.selectedTask.date,link: this.props.selectedTask.link})}>
        Edit Task
      </button>
      <button style={this.props.style.deleteButton}
        onClick={() => this.props.deleteFunction()}
      >
        Delete Task
      </button>
      </div>
      }
    </div>)}
    {this.state.editing&&!this.props.loadingDetails&&(<div style={this.state.style.form}>
      <p>Name:</p>
      <input style={{...this.state.style.formField}} type="text" value={this.state.name} placeholder={this.props.selectedTask.name} onChange={(e) => this.setState({name: e.target.value})}/>
      <p>Due Date:</p>
      <input style={this.state.style.formField} value={this.state.date} placeholder={this.props.selectedTask.date} onChange={(e) => this.setState({date: e.target.value})}/>
      <p>Link:</p>
      <input style={this.state.style.formField} value={this.state.link} placeholder={this.props.selectedTask.link} onChange={(e) => this.setState({link: e.target.value})}/>
      <button style={this.state.style.formButton} onClick={() => {this.setState({editing: false});this.props.updateTask(this.props.selectedTask.id, {id: this.props.selectedTask.id, name: this.state.name, link: this.state.link, date: this.state.date, status: this.props.selectedTask.status})}}>Save Changes</button>
      <button style={{...this.state.style.formButton, backgroundColor: "#ff6961"}} onClick={() => this.setState({editing: false})}>Cancel</button>
    </div>)}
    {this.props.loadingDetails&&(
      <p>Loading...</p>
    )}
    </div>
    )
  }
}



const condition = authUser => !!authUser;

const ClassesPage = compose(
  withRouter,
  withFirebase
)(ClassesPageBase)

export default withAuthorization(condition)(ClassesPage);
